import Autobahn from 'autobahn-react';

export const AutobahnReact = Autobahn;

export default AutobahnReact;
